import { apiRequest } from '@/core';
import { type DeleteEventRequestParams } from './types';

export const deleteEventRequest = async ({
  eventId,
}: DeleteEventRequestParams) =>
  apiRequest<void>({
    endpoint: `api/events/${eventId}`,
    method: 'DELETE',
  });
